import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navigation } from '@/components/Navigation';
import { Footer } from '@/components/Footer';
import { Toaster } from '@/components/ui/sonner';
import { ScrollToTop } from '@/components/ScrollToTop';

// Pages
import { Home } from '@/pages/Home';
import { Services } from '@/pages/Services';
import { Pricing } from '@/pages/Pricing';
import { FreeAudit } from '@/pages/FreeAudit';
import { CaseStudies } from '@/pages/CaseStudies';
import { About } from '@/pages/About';
import { Contact } from '@/pages/Contact';
import { Resources } from '@/pages/Resources';
import { Integrations } from '@/pages/Integrations';
import { Team } from '@/pages/Team';
import { NotFound } from '@/pages/NotFound';
import { ScheduleCall } from '@/pages/ScheduleCall';

// Service Pages
import { GeoAioService } from '@/pages/services/GeoAioService';
import { AiAdsService } from '@/pages/services/AiAdsService';
import { AiAgentsService } from '@/pages/services/AiAgentsService';

// Legal Pages
import { PrivacyPolicy } from '@/pages/legal/PrivacyPolicy';
import { TermsOfService } from '@/pages/legal/TermsOfService';

import '@/App.css';

function App() {
  return (
    <BrowserRouter>
      <div className="App min-h-screen flex flex-col">
        <Navigation />
        <ScrollToTop />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/geo-aio" element={<GeoAioService />} />
            <Route path="/services/ai-ads" element={<AiAdsService />} />
            <Route path="/services/ai-agents" element={<AiAgentsService />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/free-audit" element={<FreeAudit />} />
            <Route path="/case-studies" element={<CaseStudies />} />
            <Route path="/about" element={<About />} />
            <Route path="/team" element={<Team />} />
            <Route path="/integrations" element={<Integrations />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/schedule-call" element={<ScheduleCall />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" richColors />
      </div>
    </BrowserRouter>
  );
}

export default App;
